/**
 * Sort helpers for the WorkerCombobox / ClientCombobox pickers.
 *
 * Names come from the backend as a single "name" string. For workers we
 * want alphabetical by LAST name (rightmost token) so the payroll admin
 * can find someone by scanning surname column. For clients we sort by the
 * full company name as-is.
 *
 * All comparisons are case-insensitive and locale-aware.
 */

export function lastNameOf(fullName) {
  if (!fullName) return "";
  const parts = String(fullName).trim().split(/\s+/);
  return parts[parts.length - 1] || "";
}

export function sortWorkersByLastName(workers) {
  return [...(workers || [])].sort((a, b) => {
    const la = lastNameOf(a?.name).toLowerCase();
    const lb = lastNameOf(b?.name).toLowerCase();
    const cmp = la.localeCompare(lb);
    if (cmp !== 0) return cmp;
    // Same surname → fall back to full name to keep siblings adjacent
    return (a?.name || "").toLowerCase().localeCompare((b?.name || "").toLowerCase());
  });
}

export function sortClientsByName(clients) {
  return [...(clients || [])].sort((a, b) =>
    (a?.name || "").toLowerCase().localeCompare((b?.name || "").toLowerCase()),
  );
}
